









import { Component, Prop, Vue } from 'vue-property-decorator';
import { CommandWhile } from '../../cablin/commands'
import ExprComp from '../expr/Expr.vue';
import CommandListComp from './CommandList.vue';

@Component({
  components: {
    ExprComp,
    CommandListComp,
  },
})
export default class CommandWhileComp extends Vue {
  @Prop() private cmd!: CommandWhile
}
